import { isEmpty } from "lodash";
import { useEffect, useState } from "react";

const useSEO = ( props:{ language:string, type:string, id:string } ) => {
    console.log("useSEO:", props);
    const [ fetched, setFetched ] = useState<any>(null);

    useEffect(
        () => {
            if ( !isEmpty(props.language) && !isEmpty(props.type) && !isEmpty(props.id)) {
                fetch(`${window.location.origin}/_seo/${props.language}/${props.type}/${props.id}`)
                    .then(async (response:Response) => {
                        return await response.json();
                    })
                    .then((data:any) => {
                        setFetched(data);
                    })
            }
        }, [props.id]
    )

    useEffect(
        () => {
            if ( !isEmpty(fetched?.header) ) {
                const elements = document.head.querySelectorAll('[armador-teknoloji-seo]');
                for ( let item of elements ) {
                    item.remove();
                }
                const title = document.head.querySelectorAll('title');
                for ( let item of title ) {
                    item.remove();
                }
                
                const parser = new DOMParser();
                const doc = parser.parseFromString(fetched.header, "text/html");
                document.head.insertAdjacentHTML('beforeend', doc.head.innerHTML);
            }
        }, [fetched]
    )
}

export default useSEO;